export default "__VITE_ASSET__b3ed8cd7__"